<template>
  <div class="table-responsive table-leaderboard">
    <table class="table table-hover">
      <caption v-if="stats">คิดจาก Sample Size {{calSampleSize(stats)}} req.</caption>
      <thead class="thead-dark">
        <tr>
          <th scope="col">Rank</th>
          <th scope="col" class="text-left">ISP</th>
          <th scope="col" class="text-right" title="5th percentiles">Min Avg. Speed <small>(Mbps)</small></th>
          <th scope="col" class="text-right">Avg. Speed <small>(Mbps)</small></th>
          <th scope="col" class="text-right" title="95th percentiles">Max Avg. Speed <small>(Mbps)</small></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="stats">
          <tr v-for="(item, index) in stats" :key="index">
            <th scope="row">{{index + 1}}</th>
            <td class="text-left">{{item.alias}}</td>
            <td class="text-right">{{getPercentiles(item.percentiles, percentile.min)}}</td>
            <td class="text-right">{{convertToMbps(item.Kbps_rate)}}</td>
            <td class="text-right">{{getPercentiles(item.percentiles, percentile.max)}}</td>
            <!-- <td class="text-right">{{formatNumber(item.count)}}</td> -->
          </tr>
        </template>
      </tbody>
    </table>
    <div class="table-empty" v-if="!stats">
      <p class="text-center mb-0">ไม่พบข้อมูล</p>
    </div>
  </div>
</template>

<script>
import { getPercentiles, convertToMbps, formatNumber, calSampleSize } from '@/modules/utility';

export default {
  name: 'leaderboard',
  props: ['stats'],
  data() {
    return {
      percentile: {
        min: 5,
        max: 95,
      },
    };
  },
  created() {
  },
  methods: {
    getPercentiles,
    convertToMbps,
    formatNumber,
    calSampleSize,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';

.table-leaderboard {
  .table-empty {
    padding: $spacer * 2;
    color: $gray-600;
    border: 1px solid $gray-200;
    background-color: $gray-100;
    margin-bottom: $spacer * 3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/LeaderBoard.vue